import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuándo recibo el ebook?',
    a: 'Inmediatamente después del pago recibís un correo con el enlace de descarga.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No, este ebook está diseñado para principiantes que quieren aprender desde cero.'
  }, {
    q: '¿En qué formato viene?',
    a: 'En PDF, fácil de leer en cualquier dispositivo: computadora, tablet o celular.'
  }, {
    q: '¿Puedo empezar a ganar dinero desde casa con esto?',
    a: 'Sí, incluye estrategias y ejemplos prácticos para conseguir tus primeros clientes rápidamente.'
  }, {
    q: '¿Qué pasa si no me siento lista?',
    a: 'La guía está diseñada para acompañarte paso a paso.'
  }];
  return <section className="py-24 bg-white" data-id="element-67">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <SectionHeading title="Preguntas Frecuentes" data-id="element-69" />

        <div className="space-y-4 mt-12" data-id="element-70">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-71" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className="border border-rose-100 rounded-2xl overflow-hidden bg-rose-50/50" initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} data-id="element-72">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-73">
        <span className="font-bold text-dark text-lg pr-4" data-id="element-74">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="shrink-0 bg-white p-1 rounded-full shadow-sm" data-id="element-75">
          <ChevronDown className="w-5 h-5 text-rose-500" data-id="element-76" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-77">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-78">
            <div className="px-6 pb-5 text-dark-light" data-id="element-79">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}